import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AiOutlineDoubleLeft } from 'react-icons/ai';
import axios from 'config/axios';
import Table from 'components/Table';

import './index.css';

type StudentsProps = {
    students: any[];
    setStudents: ({}) => void;
    updateStudents: boolean;
};

function Students({ 
    students,
    setStudents,
    updateStudents
}: StudentsProps) {
    const navigate = useNavigate();
    const { instructorId } = useParams();

    const addStudent = (studentId: string) => {
        axios.post('tutors/tutors/student/add/', {
                tutorId: instructorId,
                studentId: studentId
            })
            .then(res => {
                setStudents(res.data.students);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const removeStudent = (studentId: string) => {
        axios.post('tutors/tutors/student/remove/', {
                tutorId: instructorId,
                studentId: studentId
            })
            .then(res => {
                setStudents(res.data.students);
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <div className='instructor-students'>
            {updateStudents
            ?   <Table
                    className='instructor-students__table'
                    header={['', 'ID', 'Name', 'Student Email']}
                    rows={students.filter(student => student.isAssigned).map(student => ([
                        <p className='instructor-students__remove'>Remove</p>,
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => student.isAssigned).map(student => ([
                        () => removeStudent(student.firebaseId),
                        null,
                        null,
                        null
                    ]))}
                />
            :   <Table
                    className='instructor-students__table'
                    header={['ID', 'Name', 'Student Email']}
                    columnTypes={['number', 'string', 'string']}
                    rows={students.filter(student => student.isAssigned).map(student => ([
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => student.isAssigned).map(student => ([
                        null,
                        () => navigate(`/students/${student.id}`),
                        null
                    ]))}
                />
            }
            {updateStudents && <>
                <AiOutlineDoubleLeft className='instructor-students__arrow' />
                <Table
                    className='instructor-students__table'
                    header={['', 'ID', 'Name', 'Student Email']}
                    rows={students.filter(student => !student.isAssigned).map(student => ([
                        'Add',
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => !student.isAssigned).map(student => ([
                        () => addStudent(student.firebaseId),
                        null,
                        null,
                        null
                    ]))}
                />
            </>}
        </div>
    );
}

export default Students;